import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const ChevronCircleUp = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M16 30C8.28 30 2 23.72 2 16C2 8.28 8.28 2 16 2C23.72 2 30 8.28 30 16C30 23.72 23.72 30 16 30ZM16 4C9.383 4 4 9.383 4 16C4 22.617 9.383 28 16 28C22.617 28 28 22.617 28 16C28 9.383 22.617 4 16 4Z" />
		<path d="M16 14.281L20.376 17.781C20.547 17.918 20.764 18.001 21 18.001C21.552 18.001 22 17.553 22 17.001C22 16.685 21.853 16.404 21.624 16.221L16.623 12.221C16.452 12.084 16.235 12.002 15.999 12.002C15.763 12.002 15.546 12.084 15.375 12.221L10.374 16.221C10.145 16.404 9.99799 16.686 9.99799 17.001C9.99799 17.553 10.446 18.001 10.998 18.001C11.234 18.001 11.451 17.919 11.622 17.781L15.998 14.281H16Z" />
	</svg>
);

export default ChevronCircleUp;
